import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { TransportationEntryService } from 'src/app/service/document-control/transportation-entry.service';
import { HeaderCheckboxComponent } from '../../grid/header-checkbox.component';
import { RowCheckboxComponent } from '../../grid/row-checkbox.component';

@Component({
    selector: 'app-teassign-invoice',
    templateUrl: './teassign-invoice.component.html',
    styleUrls: ['./teassign-invoice.component.scss'],
    standalone: false
})
export class TEAssignInvoiceComponent implements OnInit {
  @ViewChild('AssignGrid') AssignGrid;
  @ViewChild('UnassignGrid') UnassignGrid;
  gridApi: any;
  icons: {};
  frameworkComponents: {};
  context: {};

  eventType: string;
  tenumber: number;
  shipmentTypeId;
  headerChecked
  recentcheckedbox
  rowChecked
  oldDataArray: any = [];
  updatedRowIds = [];
  columnDefs = [];
  displayRowData = [];
  errormsg: string;
  defaultColDef: {};

  assigneeRowData = []
  unassigneeRowData = []

  positiveButtonLabel;
  selectedTab = 'Assigned';
  constructor(public dialogRef: MatDialogRef<TEAssignInvoiceComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly transportationEntryService: TransportationEntryService, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {};
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
  }
  ngOnInit(): void {
    this.eventType = this.dataStore.eventType
    this.tenumber = this.dataStore.tenumber;
    this.shipmentTypeId = this.dataStore.shipmentTypeId
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
    this.columnDefs = [
      {
        headerName: "", field: "rowCheckBox", pinned: "left", width: 30, minWidth: 30,
        headerComponentFramework: HeaderCheckboxComponent,

        cellClass: 'ui-grid-cell-contents-auto',

        cellRenderer: RowCheckboxComponent,
        cellRendererParams: { page: 'TEAssignInvoice' },
        lockVisible: true,
      },
      // {
      //   headerName: "InvoiceID", field: "invoiceid",
      //   autoHeight: true, wrapText: true,
      // },
      {
        headerName: "INVOICE", field: "invoiceNo", autoHeight: true, minWidth: 100, width: 100,
      },
      {
        headerName: "SHIP DATE", field: "shipmentDate", autoHeight: true, minWidth: 100, width: 100,
      },
      {
        headerName: "SUPPLIER", field: "te_supplier", autoHeight: true, minWidth: 100, width: 100,
      },
      {
        headerName: "MODE", field: "shipmentType", autoHeight: true, minWidth: 100, width: 100, sortable: true, unSortIcon: false, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true, filter: 'agTextColumnFilter',
      }
    ];

    this.refreshData();
  }



  async refreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.updatedRowIds = []
    await this.transportationEntryService.loadDataTransportationEntryAssignee(this.tenumber, this.shipmentTypeId).then(
      response => {
        this.assigneeRowData = response;
      }
    );
    await this.transportationEntryService.loadDataTransportationEntryUnassignee(this.shipmentTypeId).then(
      response => {
        this.unassigneeRowData = response;
      }
    );
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.setGridData();
  }

  setGridData() {
    this.positiveButtonLabel = this.selectedTab == 'Assigned' ? 'UNASSIGN' : 'ASSIGN';  // NOSONAR
    if (this.selectedTab == "Assigned") {  // NOSONAR
      this.displayRowData = this.assigneeRowData;
    } else if (this.selectedTab == "Unassigned") {  // NOSONAR
      this.displayRowData = this.unassigneeRowData;
    }
    this.oldDataArray = this.displayRowData;
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.gridApi?.refreshHeader()
    this.updatedRowIds = []
  }

  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  headerCheckChanged(checked) {
    const headerChecked = checked;
    this.headerChecked = headerChecked;
    this.gridApi?.forEachNode((rowNode, _index) => {
      const invoiceId = rowNode.data.invoiceId;
      if (headerChecked) {
        this.updatedRowIds.push(invoiceId)
        rowNode.data.rowCheckBox = true;
        rowNode.data.checkedEditMode = true;
        rowNode.setData(rowNode.data);
      } else {
        const tempObj = this.oldDataArray.find(x => x.invoiceId == rowNode.data.invoiceId)  // NOSONAR
        this.updatedRowIds.splice(this.updatedRowIds.indexOf(rowNode.data.invoiceId), 1)
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
        rowNode.setData(tempObj);
      }
    });

    this.updatedRowIds = [... new Set(this.updatedRowIds)]
  }
  userCheckChanged(checked, rowIndex) {

    this.recentcheckedbox = rowIndex;
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    this.rowChecked = checked;
    if (checked == true) {  // NOSONAR
      rowNode.setSelected(true);
      rowNode.data.checkedEditMode = true;
      rowNode.data.rowCheckBox = true;
      rowNode.setData(rowNode.data);
      this.updatedRowIds.push(rowNode.data.invoiceId)
    }

    else {
      const tempObj = this.oldDataArray.find(x => x.invoiceId == rowNode.data.invoiceId)  // NOSONAR
      this.updatedRowIds.splice(this.updatedRowIds.indexOf(rowNode.data.invoiceId), 1)
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
      rowNode.setData(tempObj);
    }
    this.updatedRowIds = [... new Set(this.updatedRowIds)]
    this.toogleHeaderCheckBox(checked);
  }

  toogleHeaderCheckBox(checked) {
    if (checked) {
      const rowCount = this.displayRowData.length;
      const selectedRowCount = this.displayRowData.filter(x => x.rowCheckBox == true).length;  // NOSONAR
      if (rowCount == selectedRowCount) {  // NOSONAR
        this.AssignGrid.gridOptions.columnDefs[0].headerComponentFramework.checked = checked;
        this.gridApi.refreshHeader();
      }
    } else {
      this.columnDefs[0].headerComponentFramework.checked = checked;
      this.gridApi.refreshHeader();
    }
  }

  getRowHeight() {
    return 30;
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {
    this.errormsg = ""
    if (this.updatedRowIds.length > 0) {
      this.saveAPICall();
    } else {
      this.showError(`Select Invoice number to be ${this.positiveButtonLabel.charAt(0)}${this.positiveButtonLabel.slice(1).toLowerCase()}`);
    }
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  saveAPICall() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    // this.updatedRowIds = []
    const invoiceIds = this.updatedRowIds.toString();
    if (this.selectedTab == "Assigned") {  // NOSONAR
      this.transportationEntryService.updateNewInvoiceUnassignee(invoiceIds).subscribe(
        response => {

          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.refreshData();
          } else {
            this.showError(response);
          }

        }, _error => {
          this.showError(this.constants.APIErrorMessage);
        }
      );
    } else if (this.selectedTab == "Unassigned") {  // NOSONAR
      this.transportationEntryService.updateNewInvoiceAssignee(this.tenumber, invoiceIds).subscribe(
        response => {

          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.refreshData();
          } else {
            this.showError(response);
          }

        }, _error => {
          this.showError(this.constants.APIErrorMessage);
        }
      );

    }
    
    this.dialogRef.close(
      { event: "SaveEvent" , eventResponse: "Success" }
    );
  }

  tabChange(event) {
    this.selectedTab = event?.tab?.textLabel;

    this.setGridData();
  }
}

